import styled from "styled-components";

export const HomeMainWrapper = styled.div`
  width: "100%";
  background-color: #060310;
`;